import { styled, SxProp } from 'dripsy';
import { observer } from 'mobx-react-lite';
import React from 'react';
import {
  EdgeInsets,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';
import { useTranslation } from 'react-i18next';

import { useViewerModel } from '@models/Viewer/ViewerModel';
import { ScrollView } from '@components';
import { ProfileFormPrivate } from './components';
import { useNavOptionsSet } from '@hooks';

const ScrollViewContainer = styled(ScrollView)({
  bg: '$background0',
  flex: 1,
});

function contentContainerStyle(props: EdgeInsets): SxProp {
  return (theme) => ({
    flexGrow: 1,
    pt: '$2',
    px: '$6',
    pb: props.bottom + theme.space.$10,
  });
}

export const UpdateProfilePrivateScreen = observer(() => {
  const { t } = useTranslation();
  const insets = useSafeAreaInsets();
  const viewer = useViewerModel();
  const user = viewer.currentUser;

  useNavOptionsSet({ title: t('updateProfilePrivate.title') });

  return (
    <ScrollViewContainer
      contentContainerSx={contentContainerStyle(insets)}
    >
      {user && <ProfileFormPrivate />}
    </ScrollViewContainer>
  );
});
